import { ROUTES } from '@core/nav';

import type { IconName } from '@shared/icon';

export type ShellNavItemId = 'home' | 'patients' | 'orders' | 'documents' | 'more';

export interface ShellNavItem {
  readonly id: ShellNavItemId;
  readonly labelKey: string;
  readonly icon: IconName;
  readonly url: string;
}

export const SHELL_NAV_ITEMS: readonly ShellNavItem[] = [
  { id: 'home', labelKey: 'shell.nav.home', icon: 'home', url: ROUTES.home },
  { id: 'patients', labelKey: 'shell.nav.patients', icon: 'people', url: ROUTES.patients },
  { id: 'orders', labelKey: 'shell.nav.orders', icon: 'clipboard', url: ROUTES.orders },
  { id: 'documents', labelKey: 'shell.nav.documents', icon: 'report', url: ROUTES.documents },
];

export const SHELL_TAB_NAV_ITEMS: readonly ShellNavItem[] = [
  ...SHELL_NAV_ITEMS,
  { id: 'more', labelKey: 'shell.nav.more', icon: 'menu', url: ROUTES.more },
];

export type ShellNavNotificationCounts = Readonly<Record<ShellNavItemId, number>>;

export const EMPTY_SHELL_NAV_COUNTS: ShellNavNotificationCounts = {
  home: 0,
  patients: 0,
  orders: 0,
  documents: 0,
  more: 0,
};
